// Types of events we want to track
export enum EventType {
  // Session Events
  SESSION_STARTED = 'session_started',
  SESSION_COMPLETED = 'session_completed',
  SESSION_PAUSED = 'session_paused',
  SESSION_RESUMED = 'session_resumed',
  
  // Preset Events
  PRESET_SELECTED = 'preset_selected',
  PRESET_SAVED = 'preset_saved',
  PRESET_SHARED = 'preset_shared',
  
  // Custom Session Events
  CUSTOM_SESSION_CREATED = 'custom_session_created',
  ADVANCED_SESSION_CREATED = 'advanced_session_created',
  PROGRESSIVE_SESSION_CREATED = 'progressive_session_created',
  
  // Ambient Sound Events
  AMBIENT_SOUND_ENABLED = 'ambient_sound_enabled',
  AMBIENT_SOUND_DISABLED = 'ambient_sound_disabled',
  AMBIENT_VOLUME_CHANGED = 'ambient_volume_changed',
  
  // Player Events
  VOLUME_CHANGED = 'volume_changed',
  WAVEFORM_CHANGED = 'waveform_changed',
  RECORDING_STARTED = 'recording_started',
  RECORDING_COMPLETED = 'recording_completed',
  
  // Navigation Events
  PAGE_VIEWED = 'page_viewed',
  EXTERNAL_LINK_CLICKED = 'external_link_clicked',
  
  // Error Events
  PLAYBACK_ERROR = 'playback_error',
  CONFIGURATION_ERROR = 'configuration_error'
}

// Properties that can be included with events
export interface EventProperties extends Record<string, unknown> {
  // Session Properties
  sessionId?: string;
  sessionDuration?: number;
  frequency?: number;
  volume?: number;
  
  // Preset Properties
  presetId?: string;
  presetName?: string;
  presetCategory?: string;
  
  // Custom Session Properties
  startFrequency?: number;
  endFrequency?: number;
  transitionTime?: number;
  waveformLeft?: string;
  waveformRight?: string;
  carrierFrequency?: number;
  
  // Ambient Sound Properties
  soundId?: string;
  soundName?: string;
  soundVolume?: number;
  
  // Error Properties
  errorCode?: string;
  errorMessage?: string;
  
  // Navigation Properties
  path?: string;
  referrer?: string;
  
  // Generic Properties
  timestamp?: number;
  deviceType?: string;
  browserInfo?: string;
}

// Analytics Plugin Payload Types
export interface AnalyticsPayload {
  properties: Record<string, unknown>;
  options?: Record<string, unknown>;
  [key: string]: unknown;
}

export interface PagePayload extends AnalyticsPayload {
  properties: {
    path: string;
    [key: string]: unknown;
  };
}

export interface TrackPayload extends AnalyticsPayload {
  event: EventType;
  properties: EventProperties;
}

export interface IdentifyPayload extends AnalyticsPayload {
  userId: string;
  traits?: Record<string, unknown>;
}

// Global type declarations
declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
    posthog: {
      init: (apiKey: string, options: { api_host: string }) => void;
      capture: (event: string, properties?: Record<string, unknown>) => void;
      identify: (userId: string, traits?: Record<string, unknown>) => void;
    };
  }
} 